import {
  RequestError,
  type PopupProps,
  Username as UsernamePopup
} from '@CS/components/Popups';

import API from '@/services/api';
import { useState } from 'react';

import type { AxiosError } from 'axios';
import type { RequestErrorInfo } from '@/services/api/types';

type UsernameProps = PopupProps & {
  showErrorPopup?: boolean;
};

export const Username = ({ showErrorPopup, ...props }: UsernameProps) => {
  const [usernameError, setUsernameError] = useState<RequestErrorInfo>();
  const cancelUsername = () => setUsernameError(undefined);

  const onSubmit = async (username: string) =>
    API.updateUser({ username }).catch(error => {
      showErrorPopup &&
        setUsernameError(API.getRequestErrorInfo(error as AxiosError));

      throw error;
    });

  return (
    <>
      <UsernamePopup onSubmit={onSubmit} {...props} />

      {usernameError && (
        <RequestError info={usernameError} onClose={cancelUsername} />
      )}
    </>
  );
};
